import { UrlConst } from "../constants";
import ResponseHandler from "./ResponseHandler";

const fetchPaymentData = (id) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    return fetch(UrlConst.FETCH_PAYMENT_DATA.replace(':id', id), requestOptions).then(ResponseHandler.handleResponse);
};

const generatePaymentLink = (id, name, email, channel) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ name, email, channel })
    };
    return fetch(UrlConst.GENERATE_PAYMENT_LINK.replace(':id', id), requestOptions).then(ResponseHandler.handleResponse);
};

const confirmClaimCode = (id, claimCode) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ claim_code: claimCode, is_guest: true })
    };
    return fetch(UrlConst.CONFIRM_CLAIM_CODE_LINK.replace(':id', id), requestOptions).then(ResponseHandler.handleResponse);
};

const fetchBankList = () => {
    return fetch(`${UrlConst.FETCH_BANKS_LINK}?is_guest=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(ResponseHandler.handleResponse);
};

const resolveBank = (bankCode, accountNumber) => {
    return fetch(`${UrlConst.RESOLVE_BANK_LINK}?is_guest=true`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({ bank_code: bankCode, account_number: accountNumber })
    }).then(ResponseHandler.handleResponse);
};

const claimPayout = (id, formData) => {
    const { channel, claim_code: claimCode, firstname, lastname,  ...data } = formData;
    return fetch(UrlConst.CLAIM_PAYOUT_LINK.replace(':id', id), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            is_guest: true,
            channel,
            claim_code: claimCode,
            data: { ...data, name: `${firstname} ${lastname}`},
        })
    }).then(ResponseHandler.handleResponse);
};

const fetchVasServices = () => {
    return fetch(`${UrlConst.FETCH_VAS_SERVICES_LINK}?is_guest=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(ResponseHandler.handleResponse);
};

const fetchVasCategories = (id) => {
    return fetch(`${UrlConst.FETCH_VAS_CATEGORIES_LINK.replace(':id', id)}?is_guest=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(ResponseHandler.handleResponse);
};

const fetchVasProducts = (id) => {
    return fetch(`${UrlConst.FETCH_VAS_PRODUCTS_LINK.replace(':id', id)}?is_guest=true`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(ResponseHandler.handleResponse);
};

const verifyVasEntity = (id, entityNumber) => {
    return fetch(`${UrlConst.VERIFY_VAS_ENTITY_LINK}?is_guest=true`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify({
            category_id: id,
            entity_number: entityNumber
        })
    }).then(ResponseHandler.handleResponse);
};

const checkPaymentStatus = (reference) => {
    return fetch(UrlConst.CHECK_PAYMENT_STATUS_LINK.replace(':reference', reference), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    }).then(ResponseHandler.handleResponse);
};

export const PaymentService = {
    fetchPaymentData,
    generatePaymentLink,
    confirmClaimCode,
    fetchBankList,
    resolveBank,
    claimPayout,
    fetchVasServices,
    fetchVasCategories,
    fetchVasProducts,
    verifyVasEntity,
    checkPaymentStatus
};
